/*
 * @Author: fanyang 1050549505@qq.com
 * @Date: 2021-09-30 11:21:18
 * @LastEditors: fanyang 1050549505@qq.com
 * @LastEditTime: 2022-07-11 10:23:20
 * @FilePath: /yhkh/src/axios/http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Axios from 'axios';
import config from '@/config'
import cookie from '@/lib/cookie';
let axios = Axios.create({
  baseURL: config.appUrl,
  timeout: 30000,
});

axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    if (cookie.getToken()) {
      config.headers['satoken'] = cookie.getToken();
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  res => {
    let data = res.data;
    if (config.sso == '1') {
      if (res.data.code === 2001) {
        cookie.clearToken();
        localStorage.clear();
        window.location.href = config.ssoUrl;
        return;
      } else if (res.data.code === 2004) {
        window.location.href = config.apiHomeIndex;
        return;
      } else {
        return Promise.resolve(res.data);
      }
    }else {
      if (res.data.code === 2001) {
        cookie.clearToken();
        localStorage.clear();
        window.location.href = window.location.pathname + '#/login';
        return;
      } else if (res.data.code === 2004) {
        window.location.href = window.location.pathname + '#/login';
        return;
      } else {
        return Promise.resolve(res.data);
      }
    }
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export const postAxios = (url, data) => {
  return axios.post(url, data);
};
// 请求头是application/json
export const postAxiosByJson = (url, data) => {
  return axios.post(url, data, { headers: { 'Content-Type': 'application/json' } });
};
export const getAxiosJsonByData = (url, data) => {
  return axios.get(url, {
    params: data,
    headers: { 'Content-Type': 'application/json' }
  }
  );
};

export const getAxios = (url, data) => {
  return axios.get(url, {
    params: data
  });
};

